import type { ReactNode } from 'react'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { featureFlagKeys } from 'shared/feature-flags/feature-keys'
import type { CommentInterface } from 'modules/comments/components/comment/comment.types'
import { EditorMode } from 'modules/comments/types'
import type { MentionInterface } from 'modules/community/components/editor/elements/mention/mention.types'
import type { PostAttachmentType } from 'modules/community/types/post-attachment'
import { SlateCommentEditor } from './slate-comment-editor'
import { TiptapCommentEditor } from './tiptap-comment-editor'

export interface CommentEditorProps {
  handleAddComment: (value: string, attachments?: PostAttachmentType[]) => void
  setActiveComment: (comment: CommentInterface | null) => void
  isRoot: boolean
  initialHtml?: string
  initialMentions?: MentionInterface[]
  mode?: EditorMode
  onCancel?: () => void
  className?: string
  editableComment?: CommentInterface
}

export const CommentEditor = (props: CommentEditorProps): ReactNode => {
  const isTiptapEnabled = useFeatureIsOn(featureFlagKeys.enableCommunityTiptapCommentEditor)
  return isTiptapEnabled ? <TiptapCommentEditor {...props} /> : <SlateCommentEditor {...props} />
}
